import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class FormLogic extends PureComponent {
	state = {
		email: '',
		emailInvalid: false,
	}

	// https://facebook.github.io/react/docs/forms.html
	inputChangeHandler = event => {
		const input = event.target;
		const value = input.type === 'checkbox' ? input.checked : input.value;
		const name = input.name;

		this.setState({
			[name]: value
		});
	}

	invalidInput = input => {
		const name = input.name;
		const value = this.state[name];
		if (! value) return (false);
		const valid = input.validity.valid;
		return !valid;
	}

	inputBlurHandler = event => {
		const input = event.target;
		const name = input.name;
		const isInvalid = this.invalidInput(input);
		this.setState({
			[`${name}Invalid`]: isInvalid,
		});
	}

	inputFocusHandler = event => {
		const input = event.target;
		const name = input.name;
		return this.resetInput(name);
	}

	resetInput = name => {
		this.setState({
			[`${name}Invalid`]: false,
		});
	}

	formHandler = event => {
		event.preventDefault();
		const { submitHandler } = this.props;
		if (! submitHandler) return;

		const { email } = this.state;
		if (! email) return this.setState({ emailInvalid: true });

		const validForm = event.target.checkValidity();
		if (! validForm) return this.setState({ emailInvalid: true });

		return submitHandler({ email });
	}

	render () {
		const {
			formHandler,
			inputChangeHandler,
			inputBlurHandler,
			inputFocusHandler,
		} = this;

		const passedProps = {
			...this.state,
			formHandler,
			inputChangeHandler,
			inputBlurHandler,
			inputFocusHandler,
		};

		return this.props.children(passedProps);
	}

	static propTypes = {
		// Container needed props
		children: PropTypes.func.isRequired,
		submitHandler: PropTypes.func,
	}
}

export default FormLogic;
